import React from 'react'

export const NotFoundPage = () => {
  return (
    <div style={{ backgroundImage: "url(/assets/404.png)" }}>NotFoundPage</div>
  )
}
